<template>
  <div class="container">
    <div
      v-if="isActive"
      class="row mb-0 flex"
      :class="{
        'pointer-events-none opacity-50': !isActive,
      }"
    >
      <VBoard
        ref="vboard"
        :key="getLocalGame.gridSize"
        :rows="getLocalGame.gridSize"
        :cols="getLocalGame.gridSize"
        :players="getLocalGame.players"
        :win-condition="getLocalGame.winCondition"
        :is-active="isActive"
      />
    </div>

    <div
      class="relative z-0 mb-8 mt-0 text-center text-xs text-white opacity-80"
    >
      Photo by
      <a
        class="underline"
        href="https://unsplash.com/@birminghammuseumstrust?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
        >Birmingham Museums Trust</a
      >
      on
      <a
        class="underline"
        href="https://unsplash.com/s/photos/abstract-art-painting?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
        >Unsplash</a
      >
    </div>
  </div>
</template>

<script>
import VBoard from '@/components/VBoard';
import VBoardMultiplayer from '@/components/VBoardMultiplayer';
import { mapGetters } from 'vuex';
import { socket } from '../main';

export default {
  components: { VBoard, VBoardMultiplayer },

  data() {
    return {
      gridSize: '3',
      players: 2,
      winCondition: 'First to 3',

      // local game
      isLocalGameCreated: false,

      // network game
      joinGameCode: '',
      isMultiplayerGameCreated: false,
      multiplayerGame: {},

      // other
      isLinkCopied: false,
      isCodeCopied: false,
      copiedTimeout: null,
    };
  },

  computed: {
    ...mapGetters(['getLocalGame']),

    userId() {
      return this.getUserId();
    },

    isActive() {
      return this.getLocalGame.gameStatus === 'active';
    },
  },

  // created() {
  //   socket.on('createdGame', (game) => {
  //     this.isMultiplayerGameCreated = true
  //     this.joinGameCode = game.gameId
  //     this.multiplayerGame = game

  //     this.$nextTick(() => {
  //       this.$refs.vboardmultiplayer.getGameData()
  //     })
  //   })

  //   socket.on('joinedGame', (game) => {
  //     this.isMultiplayerGameCreated = true
  //     this.multiplayerGame = JSON.parse(game)

  //     this.$nextTick(() => {
  //       this.$refs.vboardmultiplayer.getGameData()
  //     })
  //   })

  //   socket.on('leftGame', (game) => {
  //     this.multiplayerGame = JSON.parse(game)

  //     this.$nextTick(() => {
  //       this.$refs.vboardmultiplayer.getGameData()
  //     })
  //   })

  //   socket.on('startedGame', (game) => {
  //     this.$store.commit('SET_IS_GAME_ACTIVE', true)
  //   })
  // },

  mounted() {
    if (this.$route.query.code) {
      this.joinGameCode = this.$route.query.code;

      this.joinOnlineGame();
    }
  },

  methods: {
    socketConnection() {
      if (socket.disconnected) {
        socket.on('connect', () => {
          const engine = socket.io.engine;

          engine.once('upgrade', () => {
            console.log('upgrade complete');
          });
        });
      }
    },

    socketCreateGame() {
      const userId = this.getUserId();
      const multiplayerGame = {
        settings: {
          gridSize: this.gridSize,
          players: this.players,
          winCondition: this.winCondition,
        },
        boardState: [],
        hostId: userId,
        players: [
          {
            userId: userId,
            username: this.getUsername(),
            playerNumber: 1,
            score: 0,
          },
        ],
        isActive: false,
        activePlayer: 1,
        winner: [],
      };

      socket.emit('createGame', multiplayerGame);
      this.multiplayerGame = multiplayerGame;
    },

    getUserId() {
      return window.localStorage.getItem('id');
    },

    getUsername() {
      return window.localStorage.getItem('username');
    },

    createGame() {
      this.$store.commit('SET_IS_GAME_ACTIVE', true);
      this.isLocalGameCreated = true;
    },

    createOnlineGame() {
      this.socketConnection();
      this.socketCreateGame();
    },

    joinOnlineGame() {
      // store a little cookie to track users
      socket.emit('joinGame', {
        gameId: this.joinGameCode.toUpperCase(),
        player: {
          userId: this.userId,
          username: this.getUsername(),
        },
      });
    },

    leaveOnlineGame(userId) {
      // user left the game or was booted
      socket.emit('leaveGame', {
        gameId: this.joinGameCode.toUpperCase(),
        player: {
          userId: userId,
        },
      });
    },

    startOnlineGame() {
      socket.emit('startGame', {
        gameId: this.multiplayerGame.gameId,
        player: {
          userId: this.userId,
          username: this.getUsername(),
        },
      });
    },

    newGame() {
      if (this.isLocalGameCreated) {
        this.gridSize = '3';
        this.players = 2;
        this.winCondition = 'First to 3';
        this.isLocalGameCreated = false;

        this.$store.commit('SET_IS_GAME_ACTIVE', false);
      }

      if (this.isMultiplayerGameCreated) {
        this.$refs.vboardmultiplayer.newGame();
        this.multiplayerGame = {};
        this.isMultiplayerGameCreated = false;
        this.joinGameCode = '';
      }
    },

    restart() {
      if (this.isLocalGameCreated) {
        this.$refs.vboard.reset();
      }

      if (this.isMultiplayerGameCreated) {
        this.$refs.vboardmultiplayer.reset();
      }
    },

    copyText(string, type) {
      navigator.clipboard.writeText(string);

      if (this.copiedTimeout) {
        clearTimeout(this.copiedTimeout);
      }

      if (type === 'code') {
        this.isCodeCopied = true;
      }

      if (type === 'link') {
        this.isLinkCopied = true;
      }

      this.copiedTimeout = setTimeout(() => {
        this.isCodeCopied = false;
        this.isLinkCopied = false;
        this.copiedTimeout = null;
      }, 2000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/LocalGame.vue